import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static identifier = "local-time"
  static values = {
    timestamp: String,
    format: String
  }
  
  connect() {
    this.convertToLocalTime()
  }
  
  convertToLocalTime() {
    const serverTime = new Date(this.timestampValue)
    
    if (isNaN(serverTime)) {
      console.warn("Invalid timestamp:", this.timestampValue)
      return
    }
    
    const format = this.formatValue || "datetime"
    
    let localTimeString
    
    switch (format) {
      case "date":
        localTimeString = serverTime.toLocaleDateString()
        break
      case "time":
        localTimeString = serverTime.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
        break
      case "datetime-short":
        localTimeString = serverTime.toLocaleDateString() + " " + 
                         serverTime.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
        break
      case "datetime-full":
        localTimeString = serverTime.toLocaleDateString() + " " + 
                         serverTime.toLocaleTimeString()
        break
      default:
        localTimeString = serverTime.toLocaleDateString() + " " + 
                         serverTime.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
    }
    
    this.element.textContent = localTimeString
    this.element.title = `Server time: ${this.timestampValue}`
  }
}
